var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accusation-history"},_vm._l((_vm.list),function(item){return _c('div',{key:item.time,staticClass:"accuse-item"},[_c('div',{staticClass:"desc"},[_vm._v(_vm._s(item.desc))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.timeStr(item.time)))]),_c('div',{staticClass:"result"},[_vm._v(_vm._s(item.result))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }